import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isInternational } from 'lib/helpers';
import { logoutCandidate } from '../../actions/logoutCandidate';
import { clearCheckrProfileAuthSession } from '../../actions/candidateLogin';
import { workosLogout } from '../../actions/workosLogin';
import useAuthGateState from '../../hooks/useAuthGateState';
import { PATHS } from '../../constants';
import { getReturnPath } from '../../utils/returnPath';
import { hasCandidateCredential } from '../../utils/verificationCredentials';

// EU has no WorkOS email login, and isInternational() is always true there.
export const verificationLoginPath = () =>
  isInternational() ? `${PATHS.INTERNATIONAL}/login` : '/login';

// A session the BFF rejected is stale, so end it first; otherwise the login
// page sees a logged-in candidate and sends them straight back.
const useVerificationLogin = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { candidateLogin, portalAuth } = useAuthGateState();
  const loggedIn = candidateLogin.loggedIn || portalAuth.loggedIn;

  return useCallback(async () => {
    if (loggedIn || hasCandidateCredential(store.getState() as any)) {
      await clearCheckrProfileAuthSession();
      await dispatch(workosLogout() as any);
      // logoutCandidate waits on the unified-login broker before clearing
      // the session, so navigating early would still look logged in.
      await dispatch(logoutCandidate() as any);
    }
    navigate(verificationLoginPath(), {
      state: { prevLocation: getReturnPath(location) },
    });
  }, [dispatch, location, loggedIn, navigate, store]);
};

export default useVerificationLogin;
